/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Cloud Drive
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {CreateLocalizationBody} from './schemas/create-localization-body';

import type {CreateLocalization200} from './schemas/create-localization200';

import type {ListLocalizations200} from './schemas/list-localizations200';

import type {RetrieveLocalization200} from './schemas/retrieve-localization200';

import type {UpdateLocalizationBody} from './schemas/update-localization-body';

import type {UpdateLocalization200} from './schemas/update-localization200';

import type {UpdateUserLocaleBody} from './schemas/update-user-locale-body';

import type {UpdateUserLocale200} from './schemas/update-user-locale200';

import type {UploadLocalizationBody} from './schemas/upload-localization-body';

import type {UploadLocalization200} from './schemas/upload-localization200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Create a localization
 */
export const createLocalization = (
  createLocalizationBody: CreateLocalizationBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateLocalization200>>,
) => {
  return orvalApiFetch<CreateLocalization200>(
    {
      url: `/localizations`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: createLocalizationBody,
    },
    options,
  );
};
/**
 * @summary List all localizations
 */
export const listLocalizations = (
  options?: SecondParameter<typeof orvalApiFetch<ListLocalizations200>>,
) => {
  return orvalApiFetch<ListLocalizations200>(
    {url: `/localizations`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update a localization
 */
export const updateLocalization = (
  id: number,
  updateLocalizationBody?: UpdateLocalizationBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateLocalization200>>,
) => {
  return orvalApiFetch<UpdateLocalization200>(
    {
      url: `/localizations/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: updateLocalizationBody,
    },
    options,
  );
};
/**
 * @summary Delete a localization
 */
export const deleteLocalization = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/localizations/${id}`, method: 'DELETE'},
    options,
  );
};
/**
 * @summary Retrieve a localization
 */
export const retrieveLocalization = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveLocalization200>>,
) => {
  return orvalApiFetch<RetrieveLocalization200>(
    {url: `/localizations/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Download localization translation lines as a JSON file
 */
export const downloadLocalization = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<Blob>>,
) => {
  return orvalApiFetch<Blob>(
    {url: `/localizations/${id}/download`, method: 'GET', responseType: 'blob'},
    options,
  );
};
/**
 * @summary Upload localization translation lines from a JSON file
 */
export const uploadLocalization = (
  id: number,
  uploadLocalizationBody: UploadLocalizationBody,
  options?: SecondParameter<typeof orvalApiFetch<UploadLocalization200>>,
) => {
  const formData = new FormData();
  formData.append(`file`, uploadLocalizationBody.file);

  return orvalApiFetch<UploadLocalization200>(
    {
      url: `/localizations/${id}/upload`,
      method: 'POST',
      headers: {'Content-Type': 'multipart/form-data'},
      data: formData,
    },
    options,
  );
};
/**
 * @summary Update user's locale
 */
export const updateUserLocale = (
  updateUserLocaleBody: UpdateUserLocaleBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateUserLocale200>>,
) => {
  return orvalApiFetch<UpdateUserLocale200>(
    {
      url: `/users/me/locale`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: updateUserLocaleBody,
    },
    options,
  );
};
export type CreateLocalizationResult = NonNullable<
  Awaited<ReturnType<typeof createLocalization>>
>;
export type ListLocalizationsResult = NonNullable<
  Awaited<ReturnType<typeof listLocalizations>>
>;
export type UpdateLocalizationResult = NonNullable<
  Awaited<ReturnType<typeof updateLocalization>>
>;
export type DeleteLocalizationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLocalization>>
>;
export type RetrieveLocalizationResult = NonNullable<
  Awaited<ReturnType<typeof retrieveLocalization>>
>;
export type DownloadLocalizationResult = NonNullable<
  Awaited<ReturnType<typeof downloadLocalization>>
>;
export type UploadLocalizationResult = NonNullable<
  Awaited<ReturnType<typeof uploadLocalization>>
>;
export type UpdateUserLocaleResult = NonNullable<
  Awaited<ReturnType<typeof updateUserLocale>>
>;
